"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/information--filled/16.js"));
var _DownloadLinkBox = _interopRequireDefault(require("../DownloadLinkBox/DownloadLinkBox"));
var _Button = require("../..//Button/Button");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\nbody.with-cookiesBanner-container {\n  overflow-y: auto !important; }\n\n.cookiesBanner-container {\n  background-color: transparent;\n  top: auto;\n  bottom: 0;\n  height: auto; }\n  .cookiesBanner-container .bx--modal-content {\n    margin-bottom: 24px;\n    overflow-y: auto !important; }\n  .cookiesBanner-container .bx--modal-close {\n    display: none; }\n  .cookiesBanner-container .bx--modal-header {\n    display: none; }\n  .cookiesBanner-container .bx--modal-container {\n    width: 100%;\n    max-width: 1054px;\n    margin-inline: 16px;\n    border: 3px solid #e41b13;\n    border-width: 0px 0px 0px 3px;\n    align-self: end;\n    margin-bottom: 24px;\n    box-shadow: 1px 3px 5px #00000033; }\n  .cookiesBanner-container .container {\n    display: flex;\n    gap: 16px;\n    padding-top: 8px; }\n  .cookiesBanner-container .right-container {\n    width: 100%; }\n  .cookiesBanner-container .title,\n  .cookiesBanner-container .content {\n    font-size: 14px; }\n  .cookiesBanner-container .icon-container svg {\n    color: #e41b13; }\n  .cookiesBanner-container .button-container {\n    display: flex;\n    gap: 16px; }\n\n@media (max-width: 42rem) {\n  .cookiesBanner-container {\n    height: 0%; }\n    .cookiesBanner-container .content {\n      width: 80%; }\n    .cookiesBanner-container .button-container {\n      flex-direction: column;\n      width: 100%; }\n    .cookiesBanner-container button {\n      width: 80%;\n      max-width: 222px; }\n    .cookiesBanner-container .downloadlink-container {\n      width: min-content; }\n    .cookiesBanner-container .bx--modal-container {\n      height: fit-content;\n      width: fit-content;\n      left: 0px;\n      margin-top: 52px;\n      margin-bottom: 32px; }\n    .cookiesBanner-container .bx--modal-content {\n      overflow: hidden; } }\n";
  const fileName = "CookiesBanner_CookiesBanner";
  const element = document.querySelector("style[data-sass-component='CookiesBanner_CookiesBanner']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const CookiesBanner = _ref => {
  let {
    history,
    lang,
    onRequestClose,
    onAccept,
    onReject,
    translate
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(true);
  if (isOpen) {
    document.body.classList = 'with-cookiesBanner-container';
  }
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Modal, {
    open: isOpen,
    className: 'cookiesBanner-container',
    passiveModal: true,
    onRequestClose: onRequestClose,
    modalHeading: ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/_react.default.createElement(_.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "right-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "title sia-text-07"
  }, translate('cookies_banner.title')), /*#__PURE__*/_react.default.createElement("p", {
    className: "content sia-text-11 sia-margin-02-top sia-margin-03-bottom"
  }, translate('cookies_banner.content')), /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      paragraph_type: 'link_box',
      link: {
        original_url: `/${lang}/cms/node/54`,
        title: translate('cookies_banner.link')
      }
    }],
    history: history,
    lang: lang,
    isCMS: false
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: () => {
      onAccept();
      setIsOpen(false);
    }
  }, translate('cookies_banner.accept')), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: () => {
      onReject();
      setIsOpen(false);
    },
    kind: "secondary"
  }, translate('cookies_banner.reject'))))));
};
var _default = exports.default = CookiesBanner;